import React from "react";
import { Link } from "react-router-dom";

const Address = ({ address }) => {
  // Function to open the address in a maps application
  const openInMaps = () => {
    const formattedAddress = encodeURIComponent(address);
    window.open(
      `https://www.google.com/maps/search/?api=1&query=${formattedAddress}`,
      "_blank"
    );
  };

  return (
    <div className="text-white pb-4 mt-[-12px]">
      <h1 className="text-xl  ">{address}</h1>
      <p>
        {/* Provide a button to open the address in maps */}
        <button
          className="text-white/55 underline focus:outline-none"
          onClick={openInMaps}
          aria-label={`Open ${address} in maps`}
        >
          Open in Maps
        </button>
      </p>
    </div>
  );
};

const Footer = () => {
  return (
    <footer className="p-4 pb-24 bg-black  border-t-[0.25px] border-grey md:p-8 lg:p-10 ">
      <div className="mx-auto max-w-screen-xl text-center">
        <a
          href="/"
          className="flex justify-center items-center text-2xl font-semibold text-primary"
        >
          <h1 className="text-5xl">MSY Apparel</h1>
        </a>
        <p className="my-6 text-white ">
          The best place to get all your apparel needs met.
        </p>
        <Address address="212 23rd St, Kenner, LA 70062" />

        <ul className="flex flex-wrap text-xl text-white justify-center items-center mb-6 ">
          <li>
            <a
              href="https://www.facebook.com/SHOPMSYAPPAREL/"
              rel="noreferrer"
              target="_blank"
              className="mr-4 hover:underline md:mr-6 "
            >
              Facebook
            </a>
          </li>
          <li>
            <Link to={"/contact"} className="mr-4 hover:underline md:mr-6">
              Contact Us
            </Link>
          </li>
          <li>
            <Link to="/get-a-quote" className="mr-4 hover:underline md:mr-6">
              Need a Quote?
            </Link>
          </li>
        </ul>

        <span className="text-sm text-gray-500 sm:text-center dark:text-gray-400">
          © 2018-2023 MSY. All Rights Reserved.
        </span>
      </div>
    </footer>
  );
};

export default Footer;
